import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../actions/auth";
import { toast } from "react-toastify";
import * as Autocomplete from "react-autocomplete";
import Axios, { AxiosResponse } from "axios";
import config from "../config";

import i18n from "../config/i18next";
import { withTranslation } from "react-i18next";
import ReportModal from "./ReportModal";
import { arrayToFormData } from "../utils/functions";
import { Nav } from "react-bootstrap";

interface IState {
    query: string;
    searching: boolean;
    variants: string[];
    isOpen: boolean;
    fileInput: any;
    file: File;
}

const CancelToken = Axios.CancelToken;
let cancel: any;

class UserNavbar extends React.Component<any, IState> {
    public state: IState = {
        query: "",
        searching: false,
        isOpen: false,
        variants: [],
        fileInput: null,
        file: null,
    };

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    logoutHandler() {
        this.props.logout();
        this.props.history.push("/login");
    }

    changeLanguage(lang: string) {
        i18n.changeLanguage(lang);
        localStorage.setItem("language", lang);
    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    search() {
        if (this.state.searching && this.state.query.length > 1) {
            this.setState({
                searching: false,
            });

            return <Redirect to={"/search/" + this.state.query} />;
        }
    }



    render() {
        const { t, auth } = this.props;

        return (
            <div>

                <div className="riz-mobi__menu">
                    <div className="riz-mobi__cover">
                        <div>
                            <a role="button" className="riz-mobi__ico-close">
                                <img src="img/riz-mobi-ico-close.svg" alt="" />
                            </a>
                            <div className="riz-mobi__photo">
                                <img src={auth?.user?.image ? auth?.user?.image : "/img/default3.png"} />
                            </div>
                            <span className="riz-mobi__name">{auth?.user?.full_name}</span>
                        </div>

                        <nav className="riz-mobi__nav">
                            <ul>
                                <li><NavLink to="/user">Главная</NavLink></li>
                                <li><NavLink to="/user/objects">Объекты</NavLink></li>
                                <li><NavLink to="/user/tickets">Вопросы</NavLink></li>
                                <li><NavLink to="/user/history">История транзакций</NavLink></li>
                                <li><NavLink to="/user/settings">Настройки</NavLink></li>
                                <li><a onClick={() => this.logoutHandler()} role="button">Выход</a></li>
                            </ul>
                        </nav>

                        <div className="riz-mobi__copyright">
                            <span>Все права защищены</span>
                            <span>RizaNova ©</span>
                        </div>
                    </div>
                </div>

                <header className="riz-mobi__header">
                    <div className="wrapper">
                        <div className="riz-mobi__header-items">
                            <a role="button" className="riz-mobi__hamburger">
                                <img src="img/hamb.svg" alt="" />
                            </a>
                            <NavLink to="/user" className="riz-mobi__logo">
                                <img src="img/riz-logo-mobile.png" alt="" />
                            </NavLink>
                            <a role="button" onClick={() => this.logoutHandler()} className="riz-mobi__login">
                                <img src="img/login.svg" alt="" />
                            </a>
                        </div>
                    </div>
                </header>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        auth: state.auth,
    };
}

export default connect(mapStateToProps, { logout })(withTranslation()(UserNavbar));